var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Overlay_1;
import { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { defaultOptions } from '@slickdeals/durango/dist/javascript/decorators/defaultOptions';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { stateable } from '@slickdeals/durango/dist/javascript/decorators/stateable';
import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import BlueprintComponent from '../core/blueprintComponent';
import { mediatable } from '../decorators/mediatable';
import '../../scss/components/overlay.scss';
/** The name of the module */
export const name = 'Overlay';
/** Class names for Overlays */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-overlay";
    ClassNames["JavaScript"] = "js-overlay";
})(ClassNames || (ClassNames = {}));
/** Mediated events triggered by this module */
export var MediatedEvents;
(function (MediatedEvents) {
    MediatedEvents["Click"] = "click";
    MediatedEvents["Hide"] = "hide";
})(MediatedEvents || (MediatedEvents = {}));
let Overlay = Overlay_1 = class Overlay extends BlueprintComponent {
    /**
       * Create an Overlay UI component
       *
       * @param options Data and options to initialize the component with
       */
    constructor(options) {
        super(name, options);
        // Set the initial state
        const initialState = {
            isVisible: false,
        };
        // Initialize the state
        this.initState(initialState);
    }
    /**
       * Performs any necessary initialization for the component
       */
    async init() {
        super.init();
        // Either use an Overlay element already on the page or create one dynamically
        if (this.options.id) {
            this.element = await BlueprintComponent.loadElement(name, this.options);
        }
        else {
            this.element = Overlay_1.createElement();
        }
        // Add the element to the DOM
        this.injectIntoDom();
        // Listen for clicks
        this.element.addEventListener('click', this.handleClick.bind(this));
    }
    /**
       * Checks if the Overlay element is currently visible
       */
    isVisible() {
        return !!this.getState().isVisible;
    }
    /**
       * Show the Overlay element
       */
    show() {
        // Update the state
        this.setState({
            isVisible: true,
        });
        // Add the 'visible' class modifier to the element
        this.element.classList.add(classNameWithModifier(ClassNames.Default, 'visible'));
    }
    /**
       * Hide the Overlay element
       */
    hide() {
        // Update the state
        this.setState({
            isVisible: false,
        });
        this.mediate(MediatedEvents.Hide);
        // Remove the 'visible' class modifier from the element
        this.element.classList.remove(classNameWithModifier(ClassNames.Default, 'visible'));
    }
    /**
       * Handle any clicks registered by the Overlay element
       */
    handleClick() {
        this.mediate(MediatedEvents.Click);
    }
    /**
       * Inject the Overlay element into the DOM if it doesn't already exist
       */
    injectIntoDom() {
        if (!this.element.parentNode) {
            document.body.appendChild(this.element);
        }
    }
    /**
       * Create an Overlay HTML element
       */
    static createElement() {
        // Create the HTML element to build on
        const element = document.createElement('div');
        // Add Overlay class name
        element.classList.add(ClassNames.Default, ClassNames.JavaScript);
        return element;
    }
};
Overlay = Overlay_1 = __decorate([
    stateable(name),
    defaultOptions({
        id: '',
    }),
    mediatable(name, Object.values(MediatedEvents)),
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
    })
], Overlay);
export default Overlay;
BlueprintComponent.instantiate(name);
